<div class="c-appContainer">
  <!-- navbar -->
  <sv-navbar></sv-navbar>

  <div>
    <!-- content -->
    <!-- <sv-sidebar></sv-sidebar> -->

    <!-- <div id="content">
      <router-outlet></router-outlet>
      <sv-confirm-dialog></sv-confirm-dialog>
    </div> -->
    <router-outlet></router-outlet>
    <sv-confirm-dialog></sv-confirm-dialog>
  </div>
</div>
